import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { updateAssetsRentRequestsDocument } from '@api/assetsRentDocuments';

import { IUpdateAssetRequestDocumentDTO } from '@interfaces/rent/dto/assetRentDocumentsDTO';

import { ESnackbarTypes } from '@enums/common';

import { ASSET_REQUEST_DOCUMENTS, ASSET_REQUEST_UPDATE_DOCUMENT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateUpdateAssetRequestDocument = (closeModals: () => void) => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: updateDocument,
		isLoading: isLoadingUpdateDocument,
	} = useMutation<IUpdateAssetRequestDocumentDTO>({
		mutationKey: [ASSET_REQUEST_UPDATE_DOCUMENT],
		mutationFn: updateAssetsRentRequestsDocument,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.updatedAssetRequestDocument,
				type: ESnackbarTypes.success,
			}));

			closeModals();

			return [queryClient.invalidateQueries([ASSET_REQUEST_DOCUMENTS])];
		},
		onError: () => {
			dispatch(setSnackbar({
				message: responseMessages.updateErrorAssetRequestDocument,
				type: ESnackbarTypes.error,
			}));
		},
	});

	return {
		updateDocument,
		isLoadingUpdateDocument,
	};
};
